<template>
  <div class="gen-staff">
    <div class="page-title-set">
      <h3 class="page-title">
        社員紹介<br>
        <KurehaArrow class="kureha_arrow" :width="270" />
      </h3>
      <p class="page-catch">
        企画・営業職種
      </p>
    </div>
    <div class="staff-entrance">
      <section class="stafflink">
        <router-link to="/newgraduate/gen/staff/01">
          <picture>
            <source srcset="../../assets/img/gen/staff/entrance/01.jpg"
                    media="(min-width: 768px)">
            <source srcset="../../assets/img/gen/staff/entrance/01_sp.jpg"
                    media="(max-width: 767px)">
            <img src="../../assets/img/gen/staff/entrance/01.jpg" alt="01 飯野真" />
          </picture>
        </router-link>
      </section>
      <section class="stafflink">
        <router-link to="/newgraduate/gen/staff/02">
          <picture>
            <source srcset="../../assets/img/gen/staff/entrance/02.jpg"
                    media="(min-width: 768px)">
            <source srcset="../../assets/img/gen/staff/entrance/02_sp.jpg"
                    media="(max-width: 767px)">
            <img src="../../assets/img/gen/staff/entrance/02.jpg" alt="02 LEE Juhee" />
          </picture>
        </router-link>
      </section>
      <section class="stafflink">
        <router-link to="/newgraduate/gen/staff/03">
          <picture>
            <source srcset="../../assets/img/gen/staff/entrance/03.jpg"
                    media="(min-width: 768px)">
            <source srcset="../../assets/img/gen/staff/entrance/03_sp.jpg"
                    media="(max-width: 767px)">
            <img src="../../assets/img/gen/staff/entrance/03.jpg" alt="03 冨塚直人" />
          </picture>
        </router-link>
      </section>
      <section class="stafflink">
        <router-link to="/newgraduate/gen/staff/04">
          <picture>
            <source srcset="../../assets/img/gen/staff/entrance/04.jpg"
                    media="(min-width: 768px)">
            <source srcset="../../assets/img/gen/staff/entrance/04_sp.jpg"
                    media="(max-width: 767px)">
            <img src="../../assets/img/gen/staff/entrance/04.jpg" alt="04 藤野 早央里" />
          </picture>
        </router-link>
      </section>
    </div>
  </div>
</template>

<script>
import KurehaArrow from "@/components/icons/KurehaArrow.vue"
export default {
  name: 'StaffEntrance',
  components: {
    KurehaArrow
  }
}
</script>
<style scoped lang="scss">
.gen-staff {
  padding: 100px 0 200px 0;
  width: 90%;
  margin: 0 auto;
  @media print,screen and (max-width: 900px) {
    padding: 100px 0 100px 0;
  }
}
// .page-title {
//   letter-spacing: 0.1em;
//   position: relative;
//   font-size: 42px;
//   text-align: center;
//   line-height: 1;
//   i {
//     font-size: 20px;
//     display: block;
//   }
//   .kureha_arrow {
//     position: relative;
//     width: 300px;
//     bottom: 5px;
//     margin-bottom: 0;
//   }
// }
.page-title-set {
  margin: 0 auto;
  text-align: center;
  width: 90%;
  letter-spacing: 0.1em;
}
.page-title {
  letter-spacing: 0.2em;
  line-height: 1em;
  display: inline-block;
  font-size: 42px;
  text-align: center;
  margin-bottom: 0.5em;
  display: inline-block;
  width: auto;
  position: relative;
  @media print, screen and (max-width: 414px) {
    font-size: 22px;
  }
}
.page-catch {
  font-size: 20px;
  line-height: 2em;
  text-align: center;
  font-weight: bold;
  margin: 0;
  margin-top: 1em;
  @media print, screen and (max-width: 414px) {
    font-size: 14px;
  }
}
.kureha_arrow {
  position: absolute;
  display: block;
  width: auto;
  bottom: -50%;
}
.staff-entrance {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 100px auto 0 auto;
  max-width: 1100px;
  @media print,screen and (max-width: 767px) {
    flex-direction: column;
  }
}
.stafflink {
  max-width: 330px;
  width: 90%;
  display: inline-block;
  transition: transform 0.2s cubic-bezier(0.075, 0.82, 0.165, 1);
  &:hover {
    transform: scale(1.02);
  }
}
</style>
